import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const BudgetPage = lazy(() => import("./web/BudgetPage.js").then((m) => ({ default: m.BudgetPage })));
const ListPage = lazy(() => import("./web/ListPage.js").then((m) => ({ default: m.ListPage })));
const ProgressPage = lazy(() => import("./web/ProgressPage.js").then((m) => ({ default: m.ProgressPage })));
const WizardPage = lazy(() => import("./web/WizardPage.js").then((m) => ({ default: m.WizardPage })));

export default defineWebModule({
  manifest,
  pages: { "": ProgressPage, "/new": WizardPage, "/budget": BudgetPage, "/all": ListPage },
});
